import React from 'react'
import { connect } from 'react-redux'
import { change as changeFieldValue, reduxForm } from 'redux-form';
import {
  getAdminEmpresa,
  getGestorEmpresa, getOperadorEmpresa,
  getGestorOperacoes,
  PERFIL_ADMIN
} from '../../security/securityContext';
import Autorizacao from '../../security/Autorizacao';
import { formatarReal } from '../../util/numberUtil';
import iconAudoria from '../../img/auditoria.png';
import buscarUltimosHistoricosPreco from '../../actions/preco/buscarUltimosHistoricosPreco';

export class Preco extends React.Component {
  selecionarPreco (preco) {
    this.props.changeFieldValue('formularioCadastroPreco', 'idPreco', preco.id);
    this.props.changeFieldValue('formularioCadastroPreco', 'cidadeOrigem', { label: preco.cidadeOrigem.nome, value: preco.cidadeOrigem.id });
    this.props.changeFieldValue('formularioCadastroPreco', 'cidadeDestino', { label: preco.cidadeDestino.nome, value: preco.cidadeDestino.id });
    this.props.changeFieldValue('formularioCadastroPreco', 'valor', preco.valor);
    this.props.changeFieldValue('formularioCadastroPreco', 'tipo', { label: preco.descricaoTipoPreco, value: preco.tipoPreco });
    this.props.changeFieldValue('formularioCadastroPreco', 'valorAntt', preco.valorAntt);
    this.props.changeFieldValue('formularioCadastroPreco', 'tarifaSeguro', preco.tarifaSeguro);
  }

  render () {
    const preco = this.props.preco;
    return (
      <div className="vx-row-item">
        <div className="vx-row-item-inner vx-row-item-inner--preco">
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Cidade origem</span>
            {preco.cidadeOrigem.nomeComUf}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Cidade destino</span>
            {preco.cidadeDestino.nomeComUf}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Tipo veículo</span>
            {preco.descricaoTipoPreco}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Valor</span>
            {formatarReal(preco.valor)}
          </div>
          <div className="vx-row-cell">
            <span className="vx-row-cell-label">Ações</span>
            <Autorizacao perfisPermitidos={[PERFIL_ADMIN,
              getAdminEmpresa(this.props.idEmpresa),
              getGestorEmpresa(this.props.idEmpresa),
              getGestorOperacoes(this.props.idEmpresa),
              getOperadorEmpresa(this.props.idEmpresa)]}>
              <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                <button type="button" className="vx-act-btn vx-act-btn--delete"
                  title="Excluir valor"
                  data-toggle="modal"
                  data-target="#modalConfirmacaoExclusaoPreco"
                  onClick={() => this.props.selecionarPreco(preco)}>
                  <span className="material-icons">delete</span>
                </button>
                <button type="button" className="vx-act-btn vx-act-btn--edit"
                  title="Editar valor"
                  data-toggle="modal"
                  data-target="#modalCadastrarPreco"
                  onClick={() => this.selecionarPreco(preco)}>
                  <span className="material-icons">edit</span>
                </button>
                <button type="button" className="vx-act-btn vx-act-btn--neutral"
                  title="Histórico de valores"
                  data-toggle="modal"
                  data-target="#modalHistoricoPrecos"
                  onClick={() => {
                    this.props.selecionarPreco(preco);
                    this.props.buscarUltimosHistoricosPreco(preco.id, this.props.empresaSelecionada.id);
                  }}>
                  <img src={iconAudoria} alt="Histórico Valores" />
                </button>
              </div>
            </Autorizacao>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps (state) {
  return { empresaSelecionada: state.empresaSelecionada }
}

export default connect(mapStateToProps, { changeFieldValue, buscarUltimosHistoricosPreco })(reduxForm({
  form: 'formularioCadastroPreco'
})(Preco))
